import { makeEmailStatuses } from 'domains/userSettings/utils/makeEmailStatuses';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useBoundEmails } from 'domains/userSettings/hooks/useBoundEmails';
import { useInviteEmail } from 'domains/userSettings/screens/Teammates/components/hooks/useInviteEmail';

export const useEmailData = () => {
  const { isLoggedIn } = useAuth();

  const {
    emails,
    loading: isLoadingBoundEmails,
    state: { isUninitialized },
  } = useBoundEmails({ skipFetching: !isLoggedIn });

  const [inviteEmail, isInviteEmailValid] = useInviteEmail();

  const {
    confirmedEmail,
    isEmailConfirmed,
    isEmailLinkExpired,
    isEmailNotUsed,
    isEmailPending,
    lastAddressUsed,
    lastEmailUsed,
    lastLinkExpiredEmail,
    pendingAddress,
    pendingEmail,
  } = makeEmailStatuses(emails);

  return {
    confirmedEmail,
    isEmailConfirmed,
    isEmailLinkExpired,
    isEmailNotUsed,
    isEmailPending,
    lastAddressUsed,
    lastEmailUsed,
    lastLinkExpiredEmail,
    pendingAddress,
    inviteEmail,
    isInviteEmailValid,
    isLoading: isLoadingBoundEmails,
    pendingEmail,
    isUninitialized,
  };
};
